import { Skeleton } from 'ui';
import { OtherMemberProfileSkeleton } from './other-member-profile-skeleton';

type P = {
  view?: 'list' | 'member-profile';
};

const MemberLayoutSkeleton = ({ view = 'list' }: P) => {
  switch (view) {
    case 'list':
      return (
        // TODO: make reusable ui skeleton for list pages
        <>
          <Skeleton active paragraph={{ rows: 1 }} title={false} />
          <Skeleton active paragraph={{ rows: 14 }} title={false} />
        </>
      );
    case 'member-profile':
      return <OtherMemberProfileSkeleton />;
  }
};

export default MemberLayoutSkeleton;
